import Vue from 'vue';
import Element from 'element-ui';
import BootstrapVue from 'bootstrap-vue';
import echarts from "echarts";
import 'element-ui/lib/theme-chalk/index.css';
import "font-awesome/css/font-awesome.min.css";
import './assets/iconfont/iconfont.css';
import "./assets/iconfont/iconfont.js";

import Vue2OrgTree from 'vue2-org-tree'
Vue.use(Vue2OrgTree);


//
import App from './App';
import router from './router';
import store from './store';
import mapapi from './utils/map';
import moment from "moment";
moment.locale('zh-cn')
Vue.prototype.$moment = moment
import dayjs from 'dayjs'
Vue.prototype.$dayjs = dayjs

import _ from 'lodash'
Vue.prototype._ = _
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.prototype.$mapapi = mapapi;
Vue.prototype.$echarts = echarts;
//fragments该插件注册了一个全局的VFragment组件，可以用作组件模板的包裹容器
import { Plugin } from 'vue-fragment'
Vue.use(Plugin)

Vue.use(Vant);

Vue.use(Element, { size: "small" });
Vue.use(BootstrapVue)

import VueCoreVideoPlayer from 'vue-core-video-player'
Vue.use(VueCoreVideoPlayer)
//引入layout页面布局
import defaultindex from './layout/default'
import NoHeadAndFoot from './layout/NoHeadAndFoot'
Vue.component('default-layout', defaultindex);
Vue.component('nohendandfoot-layout', NoHeadAndFoot);

import jquery from "jquery";
Vue.prototype.$ = jquery;


// 水印
import {watermark, downloadImage, downPDFFile} from './utils/watermark.js';
Vue.prototype.$watermark = watermark;
Vue.prototype.$downloadImage = downloadImage; // 图片下载
Vue.prototype.$downPDFFile = downPDFFile; // pdf下载




import * as filters from '@/utils/filters';
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
});
import * as prototypes from '@/utils/prototypes';
Object.keys(prototypes).forEach(key => {
  Vue.prototype["$" + key] = prototypes[key];
});
import components from '@/utils/components.js';
Vue.use(components);
import './permission';
Vue.config.productionTip = false;


// 发布环境增加meta
// if(process.env.NODE_ENV === 'production') {
//     var oMeta = document.createElement('meta');
//     oMeta.content = 'upgrade-insecure-requests';
//     oMeta.httpEquiv = 'Content-Security-Policy';
//     document.getElementsByTagName('head')[0].appendChild(oMeta);
// }

// v-dialogDrag: 弹窗拖拽属性
Vue.directive('dialogDrag', {
  bind(el, binding, vnode, oldVnode) {
    const dialogHeaderEl = el.querySelector('.el-dialog__header')
    const dragDom = el.querySelector('.el-dialog')
    // dialogHeaderEl.style.cursor = 'move';
    dialogHeaderEl.style.cssText += ';cursor:move;'
    dragDom.style.cssText += ';top:0px;'

    // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
    const sty = (function() {
      if (window.document.currentStyle) {
        return (dom, attr) => dom.currentStyle[attr]
      } else {
        return (dom, attr) => getComputedStyle(dom, false)[attr]
      }
    })()

    dialogHeaderEl.onmousedown = (e) => {
      // 鼠标按下，计算当前元素距离可视区的距离
      const disX = e.clientX - dialogHeaderEl.offsetLeft
      const disY = e.clientY - dialogHeaderEl.offsetTop

      const screenWidth = document.body.clientWidth // body当前宽度
      const screenHeight = document.documentElement.clientHeight // 可见区域高度(应为body高度，可某些环境下无法获取)

      const dragDomWidth = dragDom.offsetWidth // 对话框宽度
      const dragDomheight = dragDom.offsetHeight // 对话框高度

      const minDragDomLeft = dragDom.offsetLeft
      const maxDragDomLeft = screenWidth - dragDom.offsetLeft - dragDomWidth

      const minDragDomTop = dragDom.offsetTop
      const maxDragDomTop = screenHeight - dragDom.offsetTop - dragDomheight

      // 获取到的值带px 正则匹配替换
      let styL = sty(dragDom, 'left')
      let styT = sty(dragDom, 'top')

      // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
      if (styL.includes('%')) {
        styL = +document.body.clientWidth * (+styL.replace(/\%/g, '') / 100)
        styT = +document.body.clientHeight * (+styT.replace(/\%/g, '') / 100)
      } else {
        styL = +styL.replace(/\px/g, '')
        styT = +styT.replace(/\px/g, '')
      }

      document.onmousemove = function(e) {
        // 通过事件委托，计算移动的距离
        let left = e.clientX - disX
        let top = e.clientY - disY

        // 边界处理
        if (-(left) > minDragDomLeft) {
          left = -(minDragDomLeft)
        } else if (left > maxDragDomLeft) {
          left = maxDragDomLeft
        }

        if (-(top) > minDragDomTop) {
          top = -(minDragDomTop)
        } else if (top > maxDragDomTop) {
          top = maxDragDomTop
        }

        // 移动当前元素
        dragDom.style.cssText += `;left:${left + styL}px;top:${top + styT}px;`
      }

      document.onmouseup = function(e) {
        document.onmousemove = null
        document.onmouseup = null
      }
    }
  }
})

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})





// WEBPACK FOOTER //
// ./src/main.js